export default {
  switchAccount: "계정 전환",
  login: "로그인",
  loginFirst: "로그인이 필요합니다",
  start: "시작",
  hasHistory: "이전에 답변한 내용이 있습니다.",
  loadHistory: "이어서 계속하시겠습니까?",
  cancel: "아니오",
  confirm: "네",
  contact: "추가 보상 기회를 받으실 때 사용할 연락처를 남겨 주세요!",
  completed: "설문조사가 끝났습니다!",
  leaveMessage: "추첨 보상 기회를 받을 수 있도록 연락처를 남겨 주세요!",
  enterEmail: "이메일 주소를 입력해 주세요",
  enterPhone: "",
  submit: "제출",
  leave: "나가기",
  submitted: "제출 완료",
  thanks: "참여해 주셔서 감사합니다",
  opinion: "귀하의 생각을 적어 주세요.",
  prev: "이전",
  next: "다음",
  unlikely: "전혀 그렇지 않다",
  likely: "매우 그렇다",
  claimYourRewards: "유저님께 선물을 드립니다.",
  rewardSent: "보상이 발송되었습니다",
  checkInGame: "게임 내에서 확인해 주세요",
  copy: "복사하기",
  copied: "복사 완료",
  selectTips: "보기 중 하나를 선택해 주세요",
  multipleTips: "보기 중 여러 가지를 선택해 주세요",
  leastChoose: "최대 xxx개 선택",
  maxChoose: "최소 xxx개 선택",
  mustAnswer: "이 문제를 먼저 답해 주세요",
  mustWrite: "내용을 입력해 주세요",
  checkEmail: "정확한 이메일 주소를 입력해 주세요",
  isAnswer: "이미 참여한 설문조사입니다",
  unStart: "이벤트 준비중",
  end: "이벤트 종료",
  checkPhone: "",
  server: "서버를 선택하세요",
  role: "캐릭터를 선택하세요",
  common: "잠시 후 다시 시도해주세요",
  title: "설문조사",
  titleAward: "설문조사",
  leastWord: "최소 xxx자 입력하세요",
  maxWord: "최대 xxx자까지 입력하세요",
  singleChoose: "택일형",
  multiChoose: "선다형",
  matrix: "매트릭스 질문",
  score: "채점형 질문",
  textLimit: "(xx-yyy자 제한)",
  coverGiftTitle: "설문 조사 작성 하여 호화 보상 수령하기",
  "-20001": "로그인하지 않음",
  "-20002": "필수 매개변수 누락",
  "-20003": "설문조사를 찾을 수 없음",
  "-20004": "설문조사 구성 중",
  "-20005": "설문조사 중지됨",
  "-20006": "설문조사 이벤트 시작되지 않음",
  "-20007": "설문조사 이벤트 종료됨",
  "-20008": "이미 답변함",
  "-20010": "보상 배포 실패",
  "-20011": "이 설문조사의 보상이 이미 배포됨",
  "-20012": "아직 답변하지 않음",
  "-20016": "게임 ID가 유효하지 않습니다",
};
